export default __webpack_public_path__ + "static/media/dotnetcore.ca03fcd6.png";